import VueRouter from 'vue-router'
import Atualiza from '@/components/AtualizaCli/Atualiza'
import ValidaRca from '@/components/AtualizaCli/ValidaRca'

export default new VueRouter({
  mode : 'history' ,
  routes: [
    {
      path: '/',
      name: 'validarca',
      component: ValidaRca
    },
    {
      path: '/atualiza',
      name: 'atualiza',
      component: Atualiza
    },
  ]
});